import styled from 'styled-components';

import {smallRegular} from '~/shared/theme/typography';
import {flipOnLTR} from '~/shared/theme/utils';

export const NewTag = styled.span`
  ${smallRegular}
  display: block;
  background-color: ${({theme}) => theme.colors.feedbackSupportPositiveTonal};
  color: ${({theme}) => theme.colors.contentPositive};
  border-radius: 4px;
  padding: 0 6px;
  ${flipOnLTR`
    margin-right: 6px;
  `}
`;
